import { Download } from 'lucide-react';

import { Button } from '@/components/cargofl-ui';
import { downloadCsv } from '@/lib/csv';

/**
 * Export the table next to it. Disabled rather than hidden when there is nothing to
 * export, so the control does not appear and vanish as data loads.
 */
export function ExportCsvButton({
  filename,
  headers,
  rows,
  label = 'Export',
}: {
  filename: string;
  headers: string[];
  rows: unknown[][];
  label?: string;
}) {
  return (
    <Button hint={"Download these rows as a CSV — opens in Excel"}
      size="sm"
      variant="outline"
      className="gap-1.5"
      disabled={rows.length === 0}
      onClick={() => downloadCsv(filename, headers, rows)}
    >
      <Download className="size-3.5" />
      {label}
    </Button>
  );
}
